import { Paper } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Navigate } from "react-router-dom";

import InstallAppList from "~/components/pwa/InstallAppList";
import { BodyTextSmall, TitleText } from "~/components/Typographies";
import useInstallAppGate from "~/pwa/useInstallAppGate";
import useInstallPrompt from "~/pwa/useInstallPrompt";

interface AppInstallsProps {
	hosted?: boolean;
}

const AppInstalls = ({ hosted = false }: AppInstallsProps) => {
	const { t } = useTranslation("common");
	const { canShowInstall, targets } = useInstallAppGate();
	const { platform } = useInstallPrompt();

	if (!canShowInstall) return <Navigate replace={true} to="/settings" />;

	return (
		<Paper elevation={0} sx={{ p: 3 }}>
			{!hosted && (
				<TitleText bold sx={{ mb: 1 }}>
					App Installs
				</TitleText>
			)}
			<BodyTextSmall color="text.secondary" sx={{ display: "block", mb: platform === "ios" ? 3 : 0 }}>
				{t("pwaInstall.intro")}
			</BodyTextSmall>
			{platform !== "ios" && (
				<BodyTextSmall color="text.secondary" sx={{ display: "block", mb: 3 }}>
					{t("pwaInstall.introShortcuts")}
				</BodyTextSmall>
			)}
			<InstallAppList targets={targets} />
		</Paper>
	);
};

export default AppInstalls;
